


















import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { option } from './option';
import { IColorDetail, IColorRecord } from './types';
import ColorWheelUnit from './ColorUnit.vue';

// 黑白灰4色条（第30个颜色的细分色）
@Component({
  components: { ColorWheelUnit },
})
export default class ColorWheelGray extends Vue {
  @Prop() public items!: IColorDetail[];
  @Prop() public width!: number | string;
  @Prop({ type: Boolean, default: false }) public selectable!: boolean; // 是否允许选择颜色块

  public unitWidth = 0;                         // 颜色块的宽度
  public selected: IColorRecord | null = null;  // 已选中的数据

  // 容器样式
  public get wrapStyle() {
    const pieRadius = option?.series[0]?.radius[1] || '';
    const width = parseInt(`${this.width}`, 10) || 32;
    this.unitWidth = width - 2; // 去掉边框的2px
    return { border: '1px solid #ccc', width: `${width}px`, height: pieRadius };
  }

  // 数据列表
  public get list() {
    return this.items[0]?.color_list || [];
  }

  // 是否被选中
  public isSelect(record: IColorRecord) {
    const sVal = this.selected;
    const selectedVal = sVal ? `${sVal.hue}_${sVal.sb}` : '';
    return `${record.hue}_${record.sb}` === selectedVal;
  }

  // 取消选中
  @Emit('select')
  public unselect() {
    this.selected = null;
    return null;
  }

  // 颜色被选中或取消选中时
  @Emit('select')
  public onToggleSelect(record: IColorRecord) {
    this.selected = this.isSelect(record) ? null : { ...record };
    return this.selected;
  }
}
